import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DebugService {

  public enabled:boolean = false;

  constructor() { }
  
  enable(){
    this.enabled = true;
    console.log("Debug enabled");
  }

  disable(){
    this.enabled = false;
    console.log("Debug disabled");
  }

  log(source:any, str:string){
    if(!this.enabled) return;
    let constructorName = source?.constructor?.name;
    console.log("DEBUG " + (new Date()).toISOString() + " - " + constructorName + ": " + str);
  }

}
